import { FC } from 'react';

interface CourseObjectiveRowProps {
  objective: {
    id: number;
    name: string;
    description?: string;
    hasMedia?: boolean;
  };
}

export const CourseObjectiveRow: FC<CourseObjectiveRowProps> = ({ objective }) => {
  return (
    <div className="rounded-lg border border-(--neutral-white-NW800) bg-(--neutral-white-NW1000) p-3">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="m-0! [font-size:var(--fs-p4)]! font-semibold text-(--neutral-black-NB900)!">
            {objective.name}
          </p>
        </div>

        <div className="flex shrink-0 gap-2">
          {objective.hasMedia && (
            <span className="rounded-full bg-(--success-S200) px-2 py-0.5 text-xs font-medium border border-(--success-S700) leading-tight text-(--success-S700)">
              Media
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
